import {Component, OnInit, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ApiService} from '../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {UtilsService} from '../../core/services/utils/utils.service';
import {Router} from '@angular/router';
import {DashboardService} from '../dashboard.service';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';

@Component({
    selector: 'app-icons',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.css'],
    standalone: false
})
export class IconsComponent implements OnInit {

  loading = false;
  uploadingBhakts = false;
  uploadingVishwaguru = false;
  iconPayload = {
    icons: {
      bhakt: 'https://bhakts.s3.us-east-2.amazonaws.com/dev/1686218260364.jpeg',
      vishvaguru: 'https://bhakts.s3.us-east-2.amazonaws.com/dev/1686218260364.jpeg'
    }
  };
  uploadIconType: 'BHAKT' | 'VISHWAGURU';

  // IMAGE UPLOAD
  modalRef: BsModalRef;
  imageChangedEvent: any = '';
  croppedFile: any;
  aspectRatio = 1;

  option: string;
  pageLoading = true;
  loaders = Array(10).fill(0);

  constructor(private api: ApiService,
              private toastr: ToastrService,
              private modalService: BsModalService,
              private utils: UtilsService,
              private router: Router,
              private dashApi: DashboardService) {
  }

  ngOnInit(): void {
    this.getIcons();
  }

  handleClickUpload(id: any = ''): void {
    const ele = document.getElementById(id);
    if (!!ele) {
      ele.click();
    }
  }

  // IMAGE CROPPER
  fileChangeEvent(event: any, template: TemplateRef<any>, type): void {
    this.modalRef = this.modalService.show(template);
    this.aspectRatio = (type === 'BANNER' ? 2 : 1);
    this.imageChangedEvent = event;
    this.uploadIconType = type;
  }

  uploadImage(file): void {
    if (this.uploadIconType === 'BHAKT') {
      this.uploadingBhakts = true;
    } else if (this.uploadIconType === 'VISHWAGURU') {
      this.uploadingVishwaguru = true;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.api.uploadImage({file: reader.result}).subscribe(res => {
        if (this.uploadIconType === 'BHAKT') {
          this.iconPayload.icons.bhakt = res.response.url;
        } else if (this.uploadIconType === 'VISHWAGURU') {
          this.iconPayload.icons.vishvaguru = res.response.url;
        }
        this.uploadingBhakts = false;
        this.uploadingVishwaguru = false;
      }, err => {
        this.uploadingBhakts = false;
        this.uploadingVishwaguru = false;
      });
    };
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedFile = new File([base64ToFile(event.base64)], `${Date.now()}.png`);
  }

  loadImageFailed(): void {
    this.utils.toastError('Image Load failed!');
  }

  updateIcons(): void {
    this.api.updateGlobalIcons(this.iconPayload).subscribe(res => {
      this.utils.toastSuccess('Icons Updated!');
    }, err => this.utils.resErr(err));
  }

  getIcons(): void {
    this.api.getGlobalIcons().subscribe(res => {
      this.iconPayload.icons = res.response[0]?.icons ?? {
        bhakt: 'https://bhakts.s3.us-east-2.amazonaws.com/dev/1686218260364.jpeg',
        vishvaguru: 'https://bhakts.s3.us-east-2.amazonaws.com/dev/1686218260364.jpeg'
      };
      this.pageLoading = false;
    }, err => {
      this.utils.resErr(err);
      this.pageLoading = false;
    });
  }

}

